class BusyButton {
    constructor() {
        this.spinnerClass = "busyBtn";
    }

    createSpinner(){
        const spinner = document.createElement("div");
        spinner.className = this.spinnerClass;
        spinner.setAttribute("role", "alert");
        spinner.setAttribute("aria-busy", "true");
        spinner.setAttribute("aria-atomic", "true");
        spinner.setAttribute("aria-label", "Loading, please wait");

        const span1 = document.createElement("span");
        const span2 = document.createElement("span");

        spinner.append(span1, span2);
        return spinner;
    }

    show(button) {
        if (!button || !(button instanceof HTMLElement)) {
            console.error("BusyButton: Invalid button element.");
            return;
        }

        // Prevent double spinners
        if (button.querySelector(`.${this.spinnerClass}`)) return;

        const spinner = this.createSpinner();
        button.prepend(spinner);
        button.disabled = true;
        button.setAttribute("aria-disabled", "true");
    }

    clear(button = document) {
        const spinner = button.querySelector(`.${this.spinnerClass}`);
        if(button == document) {
            button = spinner?.closest("button");
        }
        spinner?.remove();
        if(button){
            button.disabled = false;
            button.removeAttribute("aria-disabled");
        }
    }
}

export default new BusyButton();